import { render } from "./ProductSkeletonV2.vue?vue&type=template&id=1f9ded19&scoped=true"
const script = {}

import "./ProductSkeletonV2.vue?vue&type=style&index=0&id=1f9ded19&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9ded19"]])

export default __exports__